import script from "./color-by-name.vue?vue&type=script&setup=true&lang=ts"
export * from "./color-by-name.vue?vue&type=script&setup=true&lang=ts"

import "./color-by-name.vue?vue&type=style&index=0&id=0527f9dc&lang=scss"

const __exports__ = script;

export default __exports__